import { ViewportScroller } from '@angular/common';
import { AfterViewChecked, AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { APIReferenceXMLSamplesPage } from 'src/app/model/shared/api-reference-xml-samples-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { PageVersionService } from 'src/app/service/page-version.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-api-reference-xml-samples-page',
  templateUrl: './api-reference-xml-samples-page.component.html',
  styleUrls: ['./api-reference-xml-samples-page.component.scss']
})
export class APIReferenceXmlSamplesPageComponent implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit {
  @Input() pageName = '';
  @Input() href: string = '';
  pageVersions: string[] = [];
  pageVersionServiceSubscription: any;
  isNoteSectionExist: boolean = false;
  isSection: boolean = false;
  alreadyScrolled: boolean = false;
  apiReferenceXMLSamplesPage: APIReferenceXMLSamplesPage = {} as APIReferenceXMLSamplesPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService, private pageVersionService: PageVersionService, private scroller: ViewportScroller) {}

  ngAfterViewChecked() {
    this.scrollToHref(this.href);
  }

  scrollToHref(value: string) {
    if (value && value.length > 0 && !this.alreadyScrolled) {
      this.scroller.scrollToAnchor(value);
    }
    // console.log('alreadyScrolled : ', this.alreadyScrolled);
    // console.log('scrollToHref : ' + value);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.alreadyScrolled = true;
    }, 2000);
  }

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'api-reference-xml-samples') {
        this.apiReferenceXMLSamplesPage.htmlTitle = title.htmlTitle;
      }
    });
    const versionQuery = { 'fields.title': this.pageName, select: 'sys.id,fields.version' };

    this.contentfulService.getPageVersions(versionQuery).then((orderRetrieveItems) => {
      this.pageVersions = orderRetrieveItems
        .filter((item: { fields: undefined }) => item.fields !== undefined)
        .map((item: { fields: { version: string } }) => item.fields.version)
        .sort();

      let selectedPageVersion = '';
      if (this.pageVersions.length > 0) {
        selectedPageVersion = this.pageVersions[0];
        // console.log(this.pageName + ' >>>> default page version : ' + selectedPageVersion);
      }

      // console.log('default selectedPageVersion : ', selectedPageVersion);
      this.getPageContentFromContentful(selectedPageVersion);
    });

    this.pageVersionServiceSubscription = this.pageVersionService.pageVersion.subscribe((pageVersionData) => {
      if (pageVersionData.pageName === this.pageName && pageVersionData.selectedPageVersion !== undefined && pageVersionData.selectedPageVersion !== '') {
        // console.log('pageVersionData : ', pageVersionData);
        this.getPageContentFromContentful(pageVersionData.selectedPageVersion);
      }
    });
  }

  getPageContentFromContentful(selectedPageVersion: string) {
    const query = selectedPageVersion === '' ? { 'fields.title': this.pageName } : { 'fields.title': this.pageName, 'fields.version': selectedPageVersion };
    this.contentfulService.getPageContentResponse(query).then((orderRetrievePageResponse) => {
      this.apiReferenceXMLSamplesPage.introductionSections = [];
      this.apiReferenceXMLSamplesPage.tableSections = [];
      this.apiReferenceXMLSamplesPage.noteSections = [];
      if (orderRetrievePageResponse.includes !== undefined) {
        this.mapBanner(orderRetrievePageResponse.includes.Entry);
        this.apiReferenceXMLSamplesPage.banner.pageName = this.pageName;
        this.apiReferenceXMLSamplesPage.banner.pageVersions = this.pageVersions;
        this.apiReferenceXMLSamplesPage.banner.defaultPageVersion = selectedPageVersion;
        this.sharedDataService.addSharedData(this.apiReferenceXMLSamplesPage.banner);
        this.mapTableSections(orderRetrievePageResponse.includes.Entry);
        this.mapNoteSection(orderRetrievePageResponse.includes.Entry);
        this.mapIntoSection(orderRetrievePageResponse.includes.Entry);
        this.mapPageInfo(orderRetrievePageResponse.items);
      }
    });
  }

  private mapBanner(orderListEntries: Entry<any>[]) {
    orderListEntries.filter((entry) => ModelValidator.isBanner(entry)).forEach((entry) => this.mapEntryToBanner(entry));
  }

  private mapEntryToBanner(entry: Entry<any>) {

    
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];

    this.apiReferenceXMLSamplesPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
  
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.apiReferenceXMLSamplesPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.apiReferenceXMLSamplesPage.banner.url = entry.fields?.url;
      this.apiReferenceXMLSamplesPage.banner.editorEmail = editorDetails?.pop();
      this.apiReferenceXMLSamplesPage.banner.editorShortName = editorDetails?.pop();
      this.apiReferenceXMLSamplesPage.banner.editorFullName = editorDetails?.pop();
      this.apiReferenceXMLSamplesPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapTableSections(orderListEntries: Entry<any>[]) {
    orderListEntries.filter((entry) => ModelValidator.isTableSection(entry)).forEach((entry) => this.mapEntryToTable(entry));
  }

  private mapEntryToTable(entry: Entry<any>) {

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    this.apiReferenceXMLSamplesPage.tableSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      table: entry.fields['table'] as string,
      heading: entry.fields['heading'] as string
    });
    this.apiReferenceXMLSamplesPage.tableSections.sort((a, b) => a.order - b.order);
  }

  private mapIntoSection(orderListEntries: Entry<any>[]) {
    orderListEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });
  }

  private mapEntryToSection(entry: Entry<any>) {
    this.isSection = true;

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    this.apiReferenceXMLSamplesPage.introductionSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order']  as number
    });
    // console.log('into title', this.apiReferenceXMLSamplesPage.introductionSections);
  }

  private mapNoteSection(orderListEntries: Entry<any>[]) {
    orderListEntries
      .filter((entry) => ModelValidator.isNote(entry))
      .forEach((entry) => {
        this.mapEntryToNoteSection(entry);
      });
  }

  private mapEntryToNoteSection(entry: Entry<any>) {
    this.isNoteSectionExist = true;

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    this.apiReferenceXMLSamplesPage.noteSections.push({
      title:pageTitle,
      iconClass: entry.fields['iconClass'] as string,
      body: entry.fields['body']  as string,
      fullTitle: '',
      group: entry.fields['group']  as string,
      order: entry.fields['order']  as number,
      noteClass: entry.fields['noteClass']  as string
    });
  }

  ngOnDestroy() {
    this.pageVersionServiceSubscription.unsubscribe();
  }
}
